import {Injectable} from '@angular/core';
import {DataService} from '@app/services/data.service';
import {WhiteboardService} from '@app/modules/whiteboard/services/whiteboard.service';
import {BlackboardService} from '@app/modules/blackboard/services/blackboard.service';
import {ChatService} from '@app/modules/chat/services/chat.service';
import {CoreService} from '@app/services/core.service';
import {WrtcService} from '@app/modules/wrtc/services/wrtc.service';
import {AssignmentService} from '@app/modules/whiteboard/services/assignment.service';
import {WebPortalMessagingService} from '@app/services/web-portal-messaging.service';
import {UserDisconnectionHandlerService} from '@app/modules/shared/services/user-disconnection-handler.service';
import {WebSocketService} from '@app/modules/shared/services/web-socket.service';
import {WhiteboardCommands} from '@app/models/commands/whiteboard-commands';
import {PrivateWhiteboardCommands} from '@app/models/commands/private-whiteboard-commands';
import {GeoGebraService} from '@app/modules/whiteboard/services/geo-gebra.service';

@Injectable({
  providedIn: 'root'
})
export class CrossInjectionService {

  constructor(
    private dataService: DataService,
    private whiteboardService: WhiteboardService,
    private geoGebraService: GeoGebraService,
    private blackboardService: BlackboardService,
    private chatService: ChatService,
    private coreService: CoreService,
    private wrtcService: WrtcService,
    private webSocketService: WebSocketService,
    private assignmentService: AssignmentService,
    private webPortalMessagingService: WebPortalMessagingService,
    private userDisconnectionHandlerService: UserDisconnectionHandlerService,

    private whiteboardCommands: WhiteboardCommands,
    private privateWhiteboardCommands: PrivateWhiteboardCommands,
  ) {
    this.assignmentService.setWebPortalMessagingService(this.webPortalMessagingService);
    this.whiteboardService.setDataService(this.dataService);
    this.blackboardService.setDataService(this.dataService);
    this.chatService.setDataService(this.dataService);
    this.coreService.setDataService(this.dataService);
    this.wrtcService.setDataService(this.dataService);
    this.assignmentService.setDataService(this.dataService);

    this.coreService.setWebPortalService(this.webPortalMessagingService);
    this.wrtcService.setCoreService(this.coreService);

    this.userDisconnectionHandlerService.setWebSocketService(this.webSocketService);
    this.userDisconnectionHandlerService.setWebRTCService(this.wrtcService);

    this.whiteboardCommands.setGeoGebraService(this.geoGebraService);
    this.privateWhiteboardCommands.setGeoGebraService(this.geoGebraService);
  }
}
